// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-icon--pdf .file-icon__shadow {
  fill: #f9e3da;
}
.file-icon--pdf .file-icon__outline,
.file-icon--pdf .file-icon__type {
  fill: #ed665f;
}

.file-icon--doc .file-icon__shadow {
  fill: #e8f0f8;
}
.file-icon--doc .file-icon__outline,
.file-icon--doc .file-icon__type {
  fill: #4585c7;
}

.file-icon--xls .file-icon__shadow {
  fill: #e0f1e6;
}
.file-icon--xls .file-icon__outline,
.file-icon--xls .file-icon__type {
  fill: #6cc08a;
}

.file-icon--psd .file-icon__shadow {
  fill: #e8f0f8;
}
.file-icon--psd .file-icon__outline,
.file-icon--psd .file-icon__type {
  fill: #4585c7;
}

.file-icon--ai .file-icon__shadow {
  fill: #f3e9d8;
}
.file-icon--ai .file-icon__outline,
.file-icon--ai .file-icon__type {
  fill: #ed9b5f;
}

.file-icon--png .file-icon__shadow {
  fill: #fbf3db;
}
.file-icon--png .file-icon__outline,
.file-icon--png .file-icon__type {
  fill: #edca5f;
}

.file-icon--jpg .file-icon__shadow {
  fill: #f1e4f6;
}
.file-icon--jpg .file-icon__outline,
.file-icon--jpg .file-icon__type {
  fill: #b276c8;
}

.file-icon--unknown .file-icon__shadow {
  fill: #e6e8ef;
}
.file-icon--unknown .file-icon__outline,
.file-icon--unknown .file-icon__type {
  fill: #afb4bc;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#root .progressContainer {
  margin-bottom: 50px;
}
#root .file-drop {
  width: 100%;
  height: 200px;
  height: 210px;
  border-radius: 20px;
  filter: drop-shadow(0px 4px 3px rgba(51, 46, 58, 0.1));
  margin-top: auto;
  border: 1px dashed #688ee8;
}
#root .file-drop .file-drop-target {
  height: 100%;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  flex-direction: column;
}
#root .file-drop .file-drop-target.file-drop-dragging-over-target {
  opacity: 0.3;
}
#root .file-drop .file-drop-target input[type=file] {
  width: 0;
  height: 0;
}
#root .file-drop .placeholder {
  font-size: 14px;
  letter-spacing: 3px;
  line-height: 26px;
  background: transparent !important;
  text-align: center;
}
#root .file-drop .placeholder span {
  color: #688ee8;
  cursor: pointer;
}

.placeholder {
  display: inline-block !important;
  min-height: 1em;
  vertical-align: middle;
  cursor: pointer !important;
  background-color: white !important;
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/styles/Fileupload.scss"],"names":[],"mappings":"AAsCM;EACE,aAAA;AArCR;AAwCM;;EAEE,aAAA;AAtCR;;AAgCM;EACE,aAAA;AA7BR;AAgCM;;EAEE,aAAA;AA9BR;;AAwBM;EACE,aAAA;AArBR;AAwBM;;EAEE,aAAA;AAtBR;;AAgBM;EACE,aAAA;AAbR;AAgBM;;EAEE,aAAA;AAdR;;AAQM;EACE,aAAA;AALR;AAQM;;EAEE,aAAA;AANR;;AAAM;EACE,aAAA;AAGR;AAAM;;EAEE,aAAA;AAER;;AARM;EACE,aAAA;AAWR;AARM;;EAEE,aAAA;AAUR;;AAhBM;EACE,aAAA;AAmBR;AAhBM;;EAEE,aAAA;AAkBR;;AAbE;EACE,SAAA;EACA,UAAA;EACA,sBAAA;AAgBJ;;AAkBM;EACE,mBAAA;AAfR;AAkBM;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,sDAAA;EACA,gBAAA;EACA,0BAAA;AAhBR;AAkBQ;EACE,YAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;AAhBV;AAkBU;EACE,YAAA;AAhBZ;AAmBU;EACE,QAAA;EACA,SAAA;AAjBZ;AAqBQ;EACE,eAAA;EACA,mBAAA;EACA,iBAAA;EAEA,kCAAA;EAGA,kBAAA;AAtBV;AAwBU;EACE,cAAA;EACA,eAAA;AAtBZ;;AA2BI;EACI,gCAAA;EACA,eAAA;EACA,sBAAA;EACA,0BAAA;EACA,kCAAA;EACA,YAAA;AAxBR","sourcesContent":["\r\n$file-types: (\r\n    pdf: (\r\n      base: #ed665f,\r\n      shadow: #f9e3da,\r\n    ),\r\n    doc: (\r\n      base: #4585c7,\r\n      shadow: #e8f0f8,\r\n    ),\r\n    xls: (\r\n      base: #6cc08a,\r\n      shadow: #e0f1e6,\r\n    ),\r\n    psd: (\r\n      base: #4585c7,\r\n      shadow: #e8f0f8,\r\n    ),\r\n    ai: (\r\n      base: #ed9b5f,\r\n      shadow: #f3e9d8,\r\n    ),\r\n    png: (\r\n      base: #edca5f,\r\n      shadow: #fbf3db,\r\n    ),\r\n    jpg: (\r\n      base: #b276c8,\r\n      shadow: #f1e4f6,\r\n    ),\r\n    unknown: (\r\n      base: #afb4bc,\r\n      shadow: #e6e8ef,\r\n    ),\r\n  );\r\n  \r\n  @each $type, $file in $file-types {\r\n    .file-icon--#{$type} {\r\n      .file-icon__shadow {\r\n        fill: map-get($file, shadow);\r\n      }\r\n  \r\n      .file-icon__outline,\r\n      .file-icon__type {\r\n        fill: map-get($file, base);\r\n      }\r\n    }\r\n  }\r\n  \r\n  * {\r\n    margin: 0;\r\n    padding: 0;\r\n    box-sizing: border-box;\r\n  \r\n    // font-family: \"Montserrat\", sans-serif;\r\n    // font-weight: 500;\r\n  }\r\n  \r\n  #root {\r\n    // margin: auto auto;\r\n    // background-color: #6d93eb;\r\n    // min-height: 100vh;\r\n    // width: 100%;\r\n    // display: flex;\r\n    // justify-content: center;\r\n    // align-items: center;\r\n    // padding: 20px;\r\n    // .container {\r\n    //   width: 350px;\r\n    //   min-height: 410px;\r\n    //   border-radius: 20px;\r\n    //   filter: drop-shadow(0px 4px 3px rgba(51, 46, 58, 0.1));\r\n    //   background-color: #ffffff;\r\n    //   padding: 24px;\r\n    //   display: flex;\r\n    //   flex-direction: column;\r\n  \r\n    //   h3 {\r\n    //     font-size: 14px;\r\n    //     letter-spacing: 3px;\r\n    //     line-height: 26px;\r\n    //     color: #3d4852;\r\n    //     font-weight: 700;\r\n    //     text-align: center;\r\n    //     margin-bottom: 20px;\r\n    //   }\r\n      .progressContainer {\r\n        margin-bottom: 50px;\r\n      }\r\n  \r\n      .file-drop {\r\n        width: 100%;\r\n        height: 200px;\r\n        height: 210px;\r\n        border-radius: 20px;\r\n        filter: drop-shadow(0px 4px 3px rgba(51, 46, 58, 0.1));\r\n        margin-top: auto;\r\n        border: 1px dashed #688ee8;\r\n  \r\n        & .file-drop-target {\r\n          height: 100%;\r\n          border-radius: 20px;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n          cursor: pointer;\r\n          flex-direction: column;\r\n  \r\n          &.file-drop-dragging-over-target {\r\n            opacity: 0.3;\r\n          }\r\n  \r\n          input[type=\"file\"] {\r\n            width: 0;\r\n            height: 0;\r\n          }\r\n        }\r\n  \r\n        .placeholder {\r\n          font-size: 14px;\r\n          letter-spacing: 3px;\r\n          line-height: 26px;\r\n        //   color: #3d4852;\r\n          background: transparent!important;\r\n        //   font-weight: 400;\r\n        //   font-family: \"Montserrat\";\r\n          text-align: center;\r\n  \r\n          span {\r\n            color: #688ee8;\r\n            cursor: pointer;\r\n          }\r\n        }\r\n      }\r\n    }\r\n    .placeholder {\r\n        display: inline-block!important;\r\n        min-height: 1em;\r\n        vertical-align: middle;\r\n        cursor: pointer!important;\r\n        background-color: white!important;\r\n        opacity: .5;\r\n    }\r\n//   }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
